import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { SubAdminRoleSyncService } from './core/socket/sub-admin-role-sync.service';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: `  
    <router-outlet />
  `,
  styles: [],
})
export class App implements OnInit{
  protected readonly title = signal('aoc-landingpage-admin');
  private readonly subAdminRoleSyncService = inject(SubAdminRoleSyncService);

  ngOnInit(): void {
    initFlowbite();
    this.subAdminRoleSyncService.init();
  }

}
